import React from "react";

const ModalScreenlayout = ({
  ModalScreen,
  Newuser,
  User_nameHandler,
  User_MobileHandler,
  User_EmailHandler,
  User_MessageHandler,
  Close_NewModalHandler,
  Submit_NewUserHandler,
  Close_AwarenessHandler,
}) => {
  return (
    <div className="absolute w-full h-screen top-0 left-0 backdrop-blur-sm bg-[#00000061] flex justify-center items-center max-[740px]:items-start  max-[740px]:pt-10">
      {/* REQUEST CALL BACK FORM */}
      {ModalScreen.is_new && (
        <div className="bg-[#fff] max-w-[30%] p-3 rounded-md max-[740px]:max-w-[90%]">
          <h3 className="text-center text-red-600 text-2xl font-semibold">
            Alert
          </h3>
          <p className="text-center text-sm my-1 font-semibold">
            Your mobile number does not show as a Teacher in our records. Please
            contact for School Admin or try a different number
          </p>
          {/* <h3 className="text-center text-blue-600 text-md font-semibold">
            Request call back form
          </h3> */}

          {/* {!ModalScreen.is_mail && (
            <div className="">
              <div className="flex flex-col my-1">
                <label htmlFor="name" className="font-semibold text-sm">
                  Name <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  id="name"
                  placeholder="enter your name"
                  value={Newuser?.name}
                  onInput={User_nameHandler}
                  className="border border-slate-400 border-solid outline-0 py-1 px-3 my-1 rounded-md max-[640px]:py-2"
                />
              </div>
              <div className="flex flex-col my-1">
                <label htmlFor="number" className="font-semibold text-sm">
                  Mobile number <span className="text-red-500">*</span>
                </label>
                <input
                  type="number"
                  id="number"
                  placeholder="enter your mobile no"
                  value={Newuser.mobile}
                  onInput={User_MobileHandler}
                  className="border border-slate-400 border-solid outline-0 py-1 px-3 my-1 rounded-md max-[640px]:py-2"
                />
              </div>
              <div className="flex flex-col my-1">
                <label htmlFor="email" className="font-semibold text-sm">
                  Email <span className="text-red-500">*</span>
                </label>
                <input
                  type="email"
                  id="email"
                  value={Newuser?.email}
                  onInput={User_EmailHandler}
                  placeholder="enter your email"
                  className="border border-slate-400 border-solid outline-0 py-1 px-3 my-1 rounded-md max-[640px]:py-2"
                />
              </div>
              <div className="flex flex-col my-1">
                <label htmlFor="Message" className="font-semibold text-sm">
                  Message
                </label>
                <textarea
                  type="text"
                  id="Message"
                  value={Newuser?.message}
                  onInput={User_MessageHandler}
                  placeholder="enter your Message"
                  className="border border-slate-400 border-solid outline-0 py-1 px-3 my-1 rounded-md max-[640px]:py-2"
                ></textarea>
              </div>

              <div className="flex justify-center items-center mt-2">
                <button
                  onClick={Close_NewModalHandler}
                  className="mx-2 text-md bg-[tomato] text-white py-1 px-3 rounded-md font-semibold"
                >
                  Close
                </button>
                <button
                  className="mx-2 text-md bg-[#2fa74c] text-white py-1 px-3 rounded-md font-semibold"
                  onClick={Submit_NewUserHandler}
                >
                  Submit
                </button>
              </div>
            </div>
          )} */}

          {/* {ModalScreen.is_mail && ( */}
          <div className="flex flex-col align-center justify-center">
            {/* <h2 className="text-center my-5 text-xl font-semibold text-emerald-600">
                Mail has been sent. We will get back to you.
              </h2> */}
            <button
              className="mx-2 text-md bg-[tomato] text-white py-1 px-3 rounded-md font-semibold"
              onClick={Close_NewModalHandler}
            >
              Close
            </button>
          </div>
          {/* )} */}
        </div>
      )}

      {/* INCOMPLETE AWARENESS */}
      {ModalScreen.is_awareness && (
        <div className="bg-[#fff] max-w-[30%] p-3 rounded-md max-[740px]:max-w-[90%] ">
          <h3 className="text-center text-red-600 text-2xl font-semibold">
            Alert
          </h3>
          <p className="text-center text-slate-600 text-1xl font-semibold my-5">
            Seems like you have not completed the SLD awareness . Please
            complete the awareness and login
          </p>

          <div className="flex flex-col align-center">
            <a
              href="https://dlearners.in/Teacher/createlogin.php"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-[#02acf8] text-center text-1xl font-semibold text-white py-1 rounded-md my-2"
            >
              Open awareness
            </a>
            <button
              className="bg-[tomato] text-center text-1xl font-semibold text-white py-1 rounded-md"
              onClick={Close_AwarenessHandler}
            >
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ModalScreenlayout;
